import React, { useEffect } from 'react';

import "./Gateway.scss";
import { Gate } from './Gate/Gate';
import { PagePops } from '../../PagePops/PagePops';
import Background from '../../Background/Background';
import { HeadPane } from '../../HeadPane/HeadPane';
import Hull from '../../Hull/Hull';
import { usePop } from '@randajan/jet-react/dom/modal';
import { UnreachableError } from './UnreachableError/UnreachableError';
import FootPane from '../../FootPane/FootPane';

export const Gateway = (props) => {
    const { children, status } = props;

    const pop = usePop({ children:<UnreachableError/>, lock:true });

    useEffect(_=>{
        if (status === "error") { pop.up(); }
        else if (status === "ready") { pop.down(); }
    }, [status]);

    return (
        <section className={`Gateway locale-${status}`}>
            <Background />
            {status !== "error" && (
                <PagePops>
                    <HeadPane />
                    <Hull />
                    <FootPane/>
                </PagePops>
            )}
            <Gate status />
        </section>
    )
}

